const doc = [({"en":({"js":({"forms":({"image_input":({"the_image_was_deleted":"The image was deleted"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;